module.exports = __webpack_public_path__ + "img/c565282.jpg";